import { GLServiceBase, ServiceRoute } from "commonui";
import { IMediaChangeImpactReportService } from "./interface";

class MediaChangeImpactReportServiceClass extends GLServiceBase<any, any> implements IMediaChangeImpactReportService {
	serviceRoute: ServiceRoute = { prefix: "content/v1/vcsReports" };

	getReportData(data: any, isUpload: boolean): Promise<any> {
		const query = `?isDataUploaded=${isUpload}`;
		return this.create(`MediaChangeImpactReport` + query, data);
	}
}

export const MediaChangeImpactReportService: () => IMediaChangeImpactReportService = () =>
	new MediaChangeImpactReportServiceClass();
